import 'select2';
import 'select2/dist/css/select2';
import { Controller } from "stimulus";
import EmvQR from '../../entrypoints/src/admin/utilities/emvqr';

export default class extends Controller {
  static targets = [ 'pixKeySelect', 'amount', 'desc', 'buttonGeneratePix' ]
  connect() {
    if (!this.hasPixKeySelectTarget)
      return;

    let qrCodeResponse = this.element.querySelector('#qr-code-response');

    this.$qrCode = qrCodeResponse.querySelector('#qr-code-replace');
    this.$qrcodeDescription = qrCodeResponse.querySelector('#qr-code-description');

    $(this.pixKeySelectTarget).select2({
      multiple: false,
      allowClear: false,
      width: 'resolve',
      escapeMarkup: (markup) => markup,
      dropdownParent: this.element.closest('.modal .modal-body')
    });
  }

  async generateQRCode(ev) {
    this.resetContainerQrCode();

    let dataset = this.pixKeySelectTarget.selectedOptions[0].dataset;
    let response = await EmvQR.code({
      key: dataset.pixKeyValue,
      amount: this.amountTarget.value,
      name: dataset.pixRecipientName,
      reference: this.descTarget.value,
      key_type: dataset.pixKeyType,
      city: dataset.pixRecipientCity
    });

    this.printOutQrCode(response);
    this.buttonGeneratePixTarget.classList.toggle('hidden', true);
  }

  resetContainerQrCode() {
    this.$qrCode.innerHTML = 'Carregando <span class="loading"></span>';
    this.$qrcodeDescription.innerHTML = '';
  }

  printOutQrCode(response) {
    this.$qrCode.innerHTML =
      `<img alt="QRCode Gerado a partir dos dados fornecidos"
            class="mx-auto print:w-84" src="${response.qrcode_base64}">`;

    let pixDetails = ""

    pixDetails +=  `<li><span class="text-bold">Chave PIX:</span> ${response.key}</li>`;

    if (response.name) {
      pixDetails += `<li><span class="text-bold">Nome:</span> ${response.name}</li>`;
    }

    if (response.key_type && response.key_type != "Outro") {
      pixDetails += `<li><span class="text-bold">Tipo de Chave:</span> ${response.key_type}</li>`;
    }

    if (!!(response.formated_amount && response.formated_amount !== '')) {
      pixDetails += `<li><span class="text-bold">Valor:</span> ${response.amount}</li>`;
    }

    if (response.reference) {
      pixDetails += `<li><span class="text-bold">Código da transferência:</span> ${response.reference}</li>`;
    }

    var description = `
      <ul class="mt-5 mb-5 pl-0 no-list-style">
        ${pixDetails}
      </ul>
      <p class="text-muted text-center text-break">
        ${response.code}
      </p>`;

    this.$qrcodeDescription.innerHTML = description;
  }
}